/* eslint-disable import/prefer-default-export */
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const SocialShare = styled.div(
  ({ theme }) => css`
    display: flex;
    width: clamp(200px, fit-content, 50%);
    align-items: center;
    color: ${theme.colors.light.darkest.hex};

    .share,
    .bookmark {
      border: 0;
      background-color: transparent;
      box-shadow: none;
      padding: 0;
    }

    .share,
    .bookmark,
    .mail {
      cursor: pointer;
    }
  `
)
